<lms-modal #modalSendDiploma size="small">
  <div class="gl-popup__title">{{ 'courses.diplomaSendTitle' | translate }}</div>
  <div class="gl-popup__close" (click)="modalSendDiploma.close()">
    <span class="glicon-close"></span>
  </div>
  <div class="margin-top-16">
    <lms-dynamic-form
      [questions]="diplomaQuestions"
      [options]="{ disableCard: true, isDirtySubmit: true }"
      (submit)="sendDiploma($event)"
    >
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="modalSendDiploma.close()"
        form-actions-before
      ></gl-button>
    </lms-dynamic-form>
  </div>
</lms-modal>
